const safeOptimizely = () => {
  // Ensure a "push" interface
  if (typeof window === 'undefined') return [];
  window.optimizely = window.optimizely || [];
  return window.optimizely;
};

export function listenForOptimizelyInitialization({ onInitialize }) {
  // Optimizely might take awhile to load.  We want to know when it finishes
  safeOptimizely().push({
    type: 'addListener',
    filter: { type: 'lifecycle', name: 'initialized' },
    handler: onInitialize,
  });

  // Optimizely may have loaded before the listener was in place to fire
  if (!Array.isArray(safeOptimizely())) {
    this.props.setAvailable();
  }

  // Check eligibility for experiments on each page change
  document.body.addEventListener('historyChanged', () => safeOptimizely().push({ type: 'activate' }));
}

export const pushOptimizelyUserAttributes = (attributes = {}) => {
  safeOptimizely().push({ type: 'user', attributes });
};
